/**
 * UI helpers for rendering product/variant sync status.
 *
 * Colors map to the design tokens semantically (green = success, orange =
 * in-flight, red = failure, gray = pending). Kept here rather than colocated
 * with a specific component because multiple tables consume it.
 */

export type SyndigoSyncStatus =
  | 'completed'
  | 'in_progress'
  | 'failed'
  | 'pending'

/**
 * Map a Syndigo sync run status to a hex color for badge/pill backgrounds.
 *
 * Hex literals are kept (not design tokens) because these render inline
 * style on dynamic pill backgrounds where Tailwind classes can't cover the
 * discriminated set.
 */
export const getStatusColor = (status: SyndigoSyncStatus): string => {
  switch (status) {
    case 'completed':
      return '#10b981' // green
    case 'in_progress':
      return '#f59e0b' // orange
    case 'failed':
      return '#ef4444' // red
    case 'pending':
    default:
      return '#6b7280' // gray
  }
}
